// @flow
import React, { Component } from 'react'
import md5 from 'js-md5'
import _ from 'lodash'
import Cookie from 'js-cookie'
import styled from 'styled-components'
import FieldSet from '../FieldSet'
import { translations, translateFunc } from '../../shared/localize'

const t = translateFunc(translations.shared_ad_accounts)

const AdAccountDiv = styled.div`
  margin-bottom: 5px;
`

const AdAccountChangedTextDiv = styled.div`
  font-size: 14px;
  margin-bottom: 15px;
  margin-top: -20px;
  font-style: normal;
`

type Props = {| cookieKey: string, sharedAdAccounts: Array<Object> |}

type State = {| isOpen: boolean |}

export default class SharedAdAccount extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    let isClosed
    if (this.isOnlyCurrent(props.sharedAdAccounts)) {
      isClosed = true
    } else {
      isClosed = this.getMd5() === this.idsHash(this.idsFromCollection(props.sharedAdAccounts))
    }

    this.state = {
      isOpen: !isClosed
    }
  }

  isOnlyCurrent(sharedAdAccounts: Array<Object>) {
    return sharedAdAccounts.length === 1
  }

  idsFromCollection(sharedAdAccounts: Array<Object>): Array<string> {
    return _.map(sharedAdAccounts, (acc) => acc.id).sort()
  }

  closed() {
    this.setIdsHashToCookie()
    this.setState({ isOpen: false })
  }

  adAccountClicked() {
    this.setIdsHashToCookie()
  }

  setIdsHashToCookie() {
    const ids = this.idsFromCollection(this.props.sharedAdAccounts)
    this.setMd5(this.idsHash(ids))
  }

  idsHash(ids: Array<string>) {
    return md5(ids.sort().join(','))
  }

  setMd5(md5Hash: string) {
    return Cookie.set(this.props.cookieKey, md5Hash)
  }

  getMd5() {
    return Cookie.get(this.props.cookieKey) || ''
  }

  render() {
    const { isOpen } = this.state
    const { sharedAdAccounts } = this.props

    return (
      <FieldSet.Modal
        isOpen={isOpen}
        onClose={() => this.closed()}
        header="Ваши кабинеты"
        maxWidth={350}
        hideBtn
      >
        {<AdAccountChangedTextDiv>{t('message')}</AdAccountChangedTextDiv>}
        {_.sortBy(sharedAdAccounts, 'isCurrent').map((adAccount) => (
          <AdAccountDiv key={adAccount.id}>
            {adAccount.isCurrent
              ? this.renderCurrentAdAccount(adAccount)
              : this.renderAdAccount(adAccount)}
          </AdAccountDiv>
        ))}
      </FieldSet.Modal>
    )
  }

  renderCurrentAdAccount(adAccount: Object) {
    return adAccount.name
  }

  renderAdAccount(adAccount: Object) {
    return (
      <a onClick={() => this.adAccountClicked()} href={adAccount.path}>
        {adAccount.name}
      </a>
    )
  }
}
